import React from 'react';
import {QCJobItemModified, QCFiltersParams} from '../../QCManager/QCManagerTypes';
import {renderStatusIcon} from '../../QCManager/QCManagerContainer';

export interface SetStatusModalContainerProps {
    params: QCFiltersParams,
    item: QCJobItemModified;
}

const SetStatusModalContainer = (props: SetStatusModalContainerProps) => {
    const {
        item,
    } = props;

    return (
        <>
            <div className="status-wrapper">
                {renderStatusIcon(item)}
            </div>
        </>
    );
};

export default SetStatusModalContainer;
